export default function ComparisonTable() {
  const rows = [
    { feature: "Organizacja", spreadsheet: "⭐⭐⭐⭐⭐", normal: "⭐⭐" },
    { feature: "Oszczędność czasu", spreadsheet: "⭐⭐⭐⭐⭐", normal: "⭐⭐" },
    { feature: "Kategorie", spreadsheet: "Tak", normal: "Nie" },
    { feature: "Porównanie", spreadsheet: "Tak", normal: "Trudne" },
    { feature: "Aktualność", spreadsheet: "Regularna", normal: "Brak" },
    { feature: "Dla początkujących", spreadsheet: "Łatwe", normal: "Skomplikowane" },
  ];

  return (
    <section className="w-full px-4 md:px-8 py-16 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            Kakobuy Spreadsheet vs Tradycyjne Wyszukiwanie
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            Zobacz, dlaczego warto korzystać z gotowych arkuszy zamiast samodzielnego przeszukiwania ofert
          </p>
        </div>

        <div className="bg-background-50 rounded-xl border border-background-200/70 overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead>
                <tr className="bg-background-100">
                  <th className="text-left px-5 py-3.5 text-xs font-semibold text-foreground-700 whitespace-nowrap">
                    Funkcja
                  </th>
                  <th className="text-center px-5 py-3.5 text-xs font-semibold text-primary-500 whitespace-nowrap">
                    Spreadsheet
                  </th>
                  <th className="text-center px-5 py-3.5 text-xs font-semibold text-foreground-600 whitespace-nowrap">
                    Normalne Szukanie
                  </th>
                </tr>
              </thead>
              <tbody>
                {rows.map((row, idx) => (
                  <tr
                    key={row.feature}
                    className={`border-t border-background-200/70 ${
                      idx % 2 === 0 ? "bg-background-50" : "bg-background-100/50"
                    }`}
                  >
                    <td className="px-5 py-3 text-foreground-800 font-medium whitespace-nowrap">
                      {row.feature}
                    </td>
                    <td className="px-5 py-3 text-center whitespace-nowrap text-primary-500 font-medium">
                      {row.spreadsheet}
                    </td>
                    <td className="px-5 py-3 text-center whitespace-nowrap text-foreground-600">
                      {row.normal}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>
  );
}